import RNWebViewApi from "./RNWebViewApi"

const createSadadPaymentRequest = async (amount, orderCode) => {
  const response =
    await RNWebViewApi.postMessage(
      {
        type: "sadadPaymentRequest",
        paymentDetails: {
          amount,
          orderCode
        }
      }
    )

  const success =
    response.code === 0 &&
    (
      response.message === "Txn:Successfully done." ||
      response.message === "تراکنش با موفقیت انجام شد"
    )

  return success
}

const createBpMellatPaymentRequest = async (amount, orderCode) => {
  const response =
    await RNWebViewApi.postMessage(
      {
        type: "bpMellatPaymentRequest",
        paymentDetails: {
          amount,
          orderCode
        }
      }
    )

  return response.resultCode === "000"

}

const createPosPaymentRequest = async (amount) => {
  const orderCode = Math.random() * 1000 | 0

  switch (window.posName) {
    case "sadad":
      return await createSadadPaymentRequest(amount, orderCode)
    case "bpMellat":
      return await createBpMellatPaymentRequest(amount, orderCode)
    default:
      return await createSadadPaymentRequest(amount, orderCode)
  }
}

export default createPosPaymentRequest